module.exports = __webpack_public_path__ + "static/img/therapy.0de5756f.png";